// ============================================================================
// UNIVERSAL DETAIL PAGE ACTION COMPONENTS
// ============================================================================

export { StatusDropdownAction } from "./StatusDropdownAction";
export { CallAction } from "./CallAction";
export { ContractGenerationAction } from "./ContractGenerationAction";
export { CompanyViewAction } from "./CompanyViewAction";

// Universal Action Handlers - Migrated to modular system
export {
  universalActionHandlers,
  getActionHandler,
  isActionSupported,
  getSupportedActionTypes,
  createEntitySpecificHandler,
  extendUniversalHandlers,
  type UniversalActionHandlers,
} from "./index-handlers";
export { executeDetailAction } from "./execute-action";

// Re-export types for convenience
export type { DetailActionProps, BaseEntity } from "../types/detailPage";
